import bootstrap from '@js/bootstrap';

const ui = [];
const { register, run } = bootstrap;

register(ui);

window.rmpl = { ...window.rmpl, run };

export { ui };
export default { register };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/error.js